import { Map, fromJS } from 'immutable';
import actions from './actions';

const initState = new Map({
  propertyList: null,
  loadingPropertyList: false,
  loadingPropertyListFailed: null,

  property: null,
  loadingProperty: false,
  loadingPropertyFailed: null,

  addingProperty: false,
  addingPropertyFailed: null,
  addedProperty: false,

  updatingProperty: false,
  updatingPropertyFailed: null,
  updatedProperty: false,

  updatingHmo: false,
  updatingHmoFailed: null,
  updatedHmo: false,

  deletingProperty: false,
  deletingPropertyFailed: null,

  postcodeLookup: null,
  postcodeLookupSearching: false,
  postcodeLookupFailedData: null,

  epcLookup: null,
  epcLookupSearching: false,
  epcLookupFailedData: null,

  hmoLookup: null,
  hmoLookupSearching: false,
  hmoLookupFailedData: null,

  propertyImages: null,
  loadingPropertyImages: false,
  loadingPropertyImagesFailed: null,

  orderingPropertyImages: false,
  orderingPropertyImagesFailed: null,

  deletingPropertyImage: false,
  deletingPropertyImageFailed: null,

  uploadingDocument: false,
  uploadingDocumentSuccess: null,
  uploadingDocumentFailed: null,

  gettingRentalData: false,
  gettingRentalDataFailed: null,
  rentalData: false,

  addingRentalData: false,
  addingRentalDataFailed: null,
  addedRentalData: false,

  updatingRentalData: false,
  updatingRentalDataSuccess: null,
  updatingRentalDataFailed: null,

  rentalTenants: false,
  gettingRentalTenants: false,
  gettingRentalTenantsFailed: null,

  addedRentalTenants: false,
  addingRentalTenants: false,
  addingRentalTenantsFailed: null,

  propertySlotData: [],
  gettingPropertySlotData: true,
  gettingPropertySlotDataFailed: [],

  enquiryGraphData: {
    enquiryTenants: null,
    enquiryData: null,
  },
  gettingEnquiryGraphData: false,
  gettingEnquiryGraphDataFailed: null,
});

export default function propertiesReducer(state = initState, action) {
  switch (action.type) {

    /// DO2_LIST_PROPERTIES
    case actions.DO2_LIST_PROPERTIES:
      return state
        .set('propertyList', null)
        .set('loadingPropertyList', true)
        .set('loadingPropertyListFailed', null)
    case actions.DO2_LIST_PROPERTIES_SUCCEEDED:
      return state
        .set('propertyList', action.payload)
        .set('loadingPropertyList', false)
        .set('loadingPropertyListFailed', null)
    case actions.DO2_LIST_PROPERTIES_FAILED:
      return state
        .set('propertyList', null)
        .set('loadingPropertyList', false)
        .set('loadingPropertyListFailed', action.payload)

    /// DO2_GET_PROPERTY
    case actions.DO2_GET_PROPERTY:
      return state
        .set('property', null)
        .set('loadingProperty', true)
        .set('loadingPropertyFailed', null)
        .set('updatingHmo', false)
        .set('updatingHmoFailed', null)
        .set('updatedHmo', false)
    case actions.DO2_GET_PROPERTY_SUCCEEDED:
      return state
        .set('property', action.payload)
        .set('loadingProperty', false)
        .set('loadingPropertyFailed', null)
    case actions.DO2_GET_PROPERTY_FAILED:
      return state
        .set('property', null)
        .set('loadingProperty', false)
        .set('loadingPropertyFailed', action.payload)

    /// DO2_ADD_PROPERTY
    case actions.DO2_ADD_PROPERTY:
      return state
        .set('addingProperty', true)
        .set('addedProperty', false)
        .set('addingPropertyFailed', null)
    case actions.DO2_ADD_PROPERTY_SUCCEEDED:
      return state
        // TODO
        // either update store.Properties.propertyList
        // or trigger DO2_LIST_PROPERTIES from saga
        .set('addingProperty', false)
        .set('addedProperty', action.payload.property.propertyHash)
        .set('addingPropertyFailed', null)
    case actions.DO2_ADD_PROPERTY_FAILED:
      return state
        .set('addingProperty', false)
        .set('addedProperty', false)
        .set('addingPropertyFailed', action.payload);
    case actions.DO2_ADD_PROPERTY_RESET:
      return state
        .set('addingProperty', false)
        .set('addedProperty', false)
        .set('addingPropertyFailed', null);

    /// DO2_UPDATE_PROPERTY
    case actions.DO2_UPDATE_PROPERTY:
      return state
        .set('updatingProperty', true)
        .set('updatingPropertyFailed', null)
        .set('updatedProperty', false)
    case actions.DO2_UPDATE_PROPERTY_SUCCEEDED:
      return state
        // TODO
        // either update store.Properties.property
        // or trigger DO2_GET_PROPERTY from saga
        .set('updatingProperty', false)
        .set('updatingPropertyFailed', null)
        .set('updatedProperty', true)
    case actions.DO2_UPDATE_PROPERTY_FAILED:
      return state
        .set('updatingProperty', false)
        .set('updatingPropertyFailed', action.payload)
        .set('updatedProperty', false)
    case actions.DO2_UPDATE_PROPERTY_RESET:
      return state
        .set('updatingProperty', false)
        .set('updatingPropertyFailed', null)
        .set('updatedProperty', false)

    /// DO2_UPDATE_HMO
    case actions.DO2_UPDATE_HMO:
      return state
        .set('updatingHmo', true)
        .set('updatingHmoFailed', null)
        .set('updatedHmo', false)
    case actions.DO2_UPDATE_HMO_SUCCEEDED:
      return state
        .set('updatingHmo', false)
        .set('updatingHmoFailed', null)
        .set('updatedHmo', action.payload.property.wholeRental)
    case actions.DO2_UPDATE_HMO_FAILED:
      return state
        .set('updatingHmo', false)
        .set('updatingHmoFailed', action.payload)
        .set('updatedHmo', false)
    case actions.DO2_UPDATE_HMO_RESET:
      return state
        .set('updatingHmo', false)
        .set('updatingHmoFailed', null)
        .set('updatedHmo', false)

    /// DO2_DELETE_PROPERTY
    case actions.DO2_DELETE_PROPERTY:
      return state
        .set('deletingProperty', true)
        .set('deletingPropertyFailed', null)
    case actions.DO2_DELETE_PROPERTY_SUCCEEDED:
      return state
        // TODO
        // either update store.Properties.propertyList
        // or trigger DO2_LIST_PROPERTIES from saga
        .set('deletingProperty', false)
        .set('deletingPropertyFailed', null)
    case actions.DO2_DELETE_PROPERTY_FAILED:
      return state
        .set('deletingProperty', false)
        .set('deletingPropertyFailed', action.payload)

    case actions.DO2_RESET_PROPERTY:
      return state
        .set('property', null)
        .set('loadingProperty', false)
        .set('loadingPropertyFailed', null)
        .set('updatingProperty', false)
        .set('updatingPropertyFailed', null)

    /// DO2_POSTCODE_LOOKUP
    case actions.DO2_POSTCODE_LOOKUP:
      return state
        .set('postcodeLookup', null)
        .set('postcodeLookupSearching', true)
        .set('postcodeLookupFailedData', null)
    case actions.DO2_POSTCODE_LOOKUP_SUCCEEDED:
      return state
        .set('postcodeLookup', action.payload)
        .set('postcodeLookupSearching', false)
        .set('postcodeLookupFailedData', null)
    case actions.DO2_POSTCODE_LOOKUP_FAILED:
      return state
        .set('postcodeLookup', null)
        .set('postcodeLookupSearching', false)
        .set('postcodeLookupFailedData', action.payload)

    /// DO2_RESET_POSTCODE_LOOKUP
    case actions.DO2_RESET_POSTCODE_LOOKUP:
      return state
        .set('postcodeLookup', null)

    /// DO2_RESET_POSTCODE_LOOKUP_FAILED_DATA
    case actions.DO2_RESET_POSTCODE_LOOKUP:
      return state
        .set('postcodeLookupFailedData', null)

    /// DO2_EPC_LOOKUP
    case actions.DO2_EPC_LOOKUP:
      return state
        .set('epcLookup', null)
        .set('epcLookupSearching', true)
        .set('epcLookupFailedData', null)
    case actions.DO2_EPC_LOOKUP_SUCCEEDED:
      return state
        .set('epcLookup', action.payload)
        .set('epcLookupSearching', false)
        .set('epcLookupFailedData', null)
    case actions.DO2_EPC_LOOKUP_FAILED:
      return state
        .set('epcLookup', null)
        .set('epcLookupSearching', false)
        .set('epcLookupFailedData', action.payload)

    /// DO2_HMO_LOOKUP
    case actions.DO2_HMO_LOOKUP:
      return state
        .set('hmoLookup', null)
        .set('hmoLookupSearching', true)
        .set('hmoLookupFailedData', null)
    case actions.DO2_HMO_LOOKUP_SUCCEEDED:
      return state
        .set('hmoLookup', action.payload)
        .set('hmoLookupSearching', false)
        .set('hmoLookupFailedData', null)
    case actions.DO2_HMO_LOOKUP_FAILED:
      return state
        .set('hmoLookup', null)
        .set('hmoLookupSearching', false)
        .set('hmoLookupFailedData', action.payload)
    case actions.DO2_HMO_LOOKUP_RESET:
      return state
        .set('hmoLookup', null)
        .set('hmoLookupSearching', false)
        .set('hmoLookupFailedData', null)

    /// DO2_LIST_PROPERTY_IMAGES
    case actions.DO2_LIST_PROPERTY_IMAGES:
      return state
        .set('loadingPropertyImages', true)
        .set('propertyImages', null)
        .set('loadingPropertyImagesFailed', null);
    case actions.DO2_LIST_PROPERTY_IMAGES_SUCCEEDED:
      return state
        .set('loadingPropertyImages', false)
        .set('propertyImages', fromJS(action.payload))
        .set('loadingPropertyImagesFailed', null);
    case actions.DO2_LIST_PROPERTY_IMAGES_FAILED:
      return state
        .set('loadingPropertyImages', false)
        .set('propertyImages', null)
        .set('loadingPropertyImagesFailed', action.payload);

    /// DO2_ORDER_PROPERTY_IMAGES
    case actions.DO2_ORDER_PROPERTY_IMAGES:
      return state
        .set('orderingPropertyImages', true)
        .set('orderingPropertyImagesFailed', null);
    case actions.DO2_ORDER_PROPERTY_IMAGES_SUCCEEDED:
      return state
        .set('orderingPropertyImages', false)
        .set('orderingPropertyImagesFailed', null)
        .setIn(['propertyImages', 'images'], fromJS(action.payload.images));
    case actions.DO2_ORDER_PROPERTY_IMAGES_FAILED:
      return state
        .set('orderingPropertyImages', false)
        .set('orderingPropertyImagesFailed', action.payload);

    /// DO2_DELETE_PROPERTY_IMAGE
    case actions.DO2_DELETE_PROPERTY_IMAGE:
      return state
        .set('deletingPropertyImage', true)
        .set('deletingPropertyImageFailed', null)
    case actions.DO2_DELETE_PROPERTY_IMAGE_SUCCEEDED:
      return state
        .set('deletingPropertyImage', false)
        .set('deletingPropertyImageFailed', null)
        .setIn(['propertyImages', 'images'], fromJS(action.payload.remainingImages));

    /// DO2_UPLOAD_PROPERTY_DOCUMENT
    case actions.DO2_UPLOAD_PROPERTY_DOCUMENT:
      return state
        .set('uploadingDocument', true)
        .set('uploadingDocumentSuccess', null)
        .set('uploadingDocumentFailed', null);
    case actions.DO2_UPLOAD_PROPERTY_DOCUMENT_SUCCESS:
      return state
        .set('uploadingDocument', false)
        .set('uploadingDocumentSuccess', action.payload)
        .set('uploadingDocumentFailed', null);
    case actions.DO2_UPLOAD_PROPERTY_DOCUMENT_FAILED:
      return state
        .set('uploadingDocument', false)
        .set('uploadingDocumentSuccess', null)
        .set('uploadingDocumentFailed', action.payload);
        
    // DO2_RENTAL_DATA_CHANGED
    case actions.DO2_RENTAL_DATA_CHANGED:
      const rentalData = fromJS(state.get('rentalData'));
      return rentalData.setIn([0, action.payload.name], fromJS(action.payload.value));

    //DO2_GET_RENTAL_DATA
    case actions.DO2_GET_RENTAL_DATA:
      return state
        .set('gettingRentalData', true)
        .set('rentalData', false)
        .set('gettingRentalDataFailed', null)
    case actions.DO2_GET_RENTAL_DATA_SUCCEEDED:
      return state
        .set('gettingRentalData', false)
        .set('rentalData', action.payload)
        .set('gettingRentalDataFailed', null)
    case actions.DO2_GET_RENTAL_DATA_FAILED:
      return state
        .set('gettingRentalData', false)
        .set('rentalData', false)
        .set('gettingRentalDataFailed', action.payload);

    //DO2_ADD_RENTAL_DATA
    case actions.DO2_ADD_RENTAL_DATA:
      return state
        .set('addingRentalData', true)
        .set('addedRentalData', false)
        .set('addingRentalDataFailed', null)
    case actions.DO2_ADD_RENTAL_DATA_SUCCEEDED:
      return state
        .set('addingRentalData', false)
        .set('addedRentalData', action.payload)
        .set('addingRentalDataFailed', null)
    case actions.DO2_ADD_RENTAL_DATA_FAILED:
      return state
        .set('addingRentalData', false)
        .set('addedRentalData', false)
        .set('addingRentalDataFailed', action.payload);

    //DO2_UPDATING_RENTAL_DATA
    case actions.DO2_UPDATE_RENTAL_DATA:
      return state
        .set('updatingRentalData', true)
        .set('updatingRentalDataSuccess', null)
        .set('updatingRentalDataFailed', null)
    case actions.DO2_UPDATE_RENTAL_DATA_SUCCEEDED:
      return state
        .set('updatingRentaData', false)
        .set('updatingRentalDataSuccess', action.payload)
        .set('updatingRentalDataFailed', false)
    case actions.DO2_UPDATE_RENTAL_DATA_FAILED:
      return state
        .set('updatingRentaData', false)
        .set('updatingRentalDataSuccess', false)
        .set('updatingRentalDataFailed', action.payload)

    // DO2_GETTING_PROPERTY_RENTAL_TENANTS
    case actions.DO2_GET_PROPERTY_RENTAL_TENANTS:
      return state
        .set('gettingRentalTenants', true)
        .set('rentalTenants', false)
        .set('gettingRentalTenantsFailed', null)
    case actions.DO2_GET_PROPERTY_RENTAL_TENANTS_SUCCEEDED:
      return state
        .set('gettingRentalTenants', false)
        .set('rentalTenants', action.payload)
        .set('gettingRentalTenantsFailed', null)
    case actions.DO2_GET_PROPERTY_RENTAL_TENANTS_FAILED:
      return state
        .set('gettingRentalTenants', false)
        .set('rentalTenants', false)
        .set('gettingRentalTenantsFailed', action.payload);

    //DO2_ADD_PROPERTY_RENTAL_TENANTS
    case actions.DO2_ADD_PROPERTY_RENTAL_TENANTS:
      return state
        .set('addingRentalTenants', true)
        .set('addedRentalTenants', false)
        .set('addingRentalTenantsFailed', null)
    case actions.DO2_ADD_PROPERTY_RENTAL_TENANTS_SUCCEEDED:
      return state
        .set('addingRentalTenants', false)
        .set('addedRentalTenants', action.payload)
        .set('addingRentalTenantsFailed', null)
    case actions.DO2_ADD_PROPERTY_RENTAL_TENANTS_FAILED:
      return state
        .set('addingRentalTenants', false)
        .set('addedRentalTenants', false)
        .set('addingRentalTenantsFailed', action.payload);
    
    // Get property slot data
    case actions.DO_GET_PROPERTY_SLOT_DATA:
      return state
        .set('gettingPropertySlotData', true);
    case actions.DO_GET_PROPERTY_SLOT_DATA_SUCCEEDED:
      return state
        .set('gettingPropertySlotData', false)
        .set('propertySlotData', action.payload);
    case actions.DO_GET_PROPERTY_SLOT_DATA_FAILED:
      return state
        .set('gettingPropertySlotData', false)
        .set('propertySlotData', action.payload);

    case actions.DO_GET_ENQUIRY_GRAPH_DATA:
      return state
        .set('enquiryGraphData', { enquiryTenants: null, enquiryData: null })
        .set('gettingEnquiryGraphData', true)
        .set('gettingEnquiryGraphDataFailed', null)
    case actions.DO_GET_ENQUIRY_GRAPH_DATA_SUCCEEDED:
      return state
        .set('enquiryGraphData', action.payload)
        .set('gettingEnquiryGraphData', false)
        .set('gettingEnquiryGraphDataFailed', null)
    case actions.DO_GET_ENQUIRY_GRAPH_DATA_FAILED:
      return state
        .set('enquiryGraphData', { enquiryTenants: null, enquiryData: null })
        .set('gettingEnquiryGraphData', false)
        .set('gettingEnquiryGraphDataFailed', action.payload)


    // TODO
    // write cases for 

    // DO2_LIST_PROPERTY_IMAGES
    // DO2_LIST_PROPERTY_IMAGES_SUCCEEDED
    // DO2_LIST_PROPERTY_IMAGES_FAILED

    // DO2_ORDER_PROPERTY_IMAGES
    // DO2_ORDER_PROPERTY_IMAGES_SUCCEEDED
    // DO2_ORDER_PROPERTY_IMAGES_FAILED

    // DO2_SET_PROPERTY_IMAGE_DELETED
    // DO2_SET_PROPERTY_IMAGE_DELETED_SUCCEEDED

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/properties2/reducer.js